import { Link } from 'react-router-dom';
import { NearbyArea } from '../../../mocks/serviceAreaCities';

interface NearbyAreasSectionProps {
  cityName: string;
  nearbyAreas: NearbyArea[];
}

export default function NearbyAreasSection({ cityName, nearbyAreas }: NearbyAreasSectionProps) {
  if (!nearbyAreas || nearbyAreas.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-oswald text-3xl md:text-4xl font-bold text-[#1A2332] mb-3">
            Nearby Areas We Serve
          </h2>
          <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
            We proudly serve {cityName} and surrounding communities throughout the Pacific Northwest
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {nearbyAreas.map((area) => (
            <Link
              key={area.slug}
              to={`/service-areas/${area.slug}`}
              className="group bg-[#F7F5F0] border border-[#E8E2D6] rounded-lg p-4 hover:border-[#E8B84B] hover:shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white border border-[#E8E2D6] rounded-full flex items-center justify-center flex-shrink-0 group-hover:border-[#E8B84B] transition-colors" aria-hidden="true">
                  <i className="ri-map-pin-line text-[#E8B84B] text-lg"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-[#1A2332] group-hover:text-[#92650a] transition-colors truncate">
                    {area.name}
                  </h3>
                </div>
                <i className="ri-arrow-right-line text-[#4A5568] group-hover:text-[#E8B84B] group-hover:translate-x-1 transition-all flex-shrink-0" aria-hidden="true"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/service-areas"
            className="inline-flex items-center gap-2 text-[#92650a] font-semibold hover:text-[#7a5508] transition-colors"
          >
            View All Service Areas
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export { NearbyAreasSection };